import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function Sucesso() {
  const location = useLocation();
  const navigate = useNavigate();
  const { formData, cadastroRealizado } = location.state || {};

  // Se não há dados ou cadastro não foi realizado, redirecionar
  if (!formData || !cadastroRealizado) {
    navigate('/cadastro');
    return null;
  }

  const voltarParaHome = () => {
    navigate('/');
  };

  const irParaCentralAssinante = () => {
    navigate('/login');
  };

  return (
    <div className="sucesso-page">
      <div className="container">
        <div className="sucesso-content">
          <div className="sucesso-card">
            <div className="sucesso-header">
              <div className="sucesso-icon">
                <i className="fas fa-check-circle"></i>
              </div>
              <h1>Cadastro Realizado com Sucesso!</h1>
              <p>Obrigado por escolher a UNET. Entraremos em contato em breve para finalizar sua instalação.</p>
            </div>

            <div className="dados-resumo">
              <h3>Resumo do Cadastro</h3>
              
              <div className="dados-pessoais">
                <h4>Dados Pessoais</h4>
                <div className="dado-item">
                  <span className="label">Nome:</span>
                  <span className="valor">{formData.nome}</span>
                </div>
                <div className="dado-item">
                  <span className="label">CPF:</span>
                  <span className="valor">{formData.cpf}</span>
                </div>
                <div className="dado-item">
                  <span className="label">Email:</span>
                  <span className="valor">{formData.email}</span>
                </div>
                <div className="dado-item">
                  <span className="label">Telefone:</span>
                  <span className="valor">{formData.telefone}</span>
                </div>
              </div>

              <div className="dados-endereco">
                <h4>Endereço de Instalação</h4>
                <div className="dado-item">
                  <span className="label">Endereço:</span>
                  <span className="valor">{formData.endereco}</span>
                </div>
                <div className="dado-item">
                  <span className="label">Bairro:</span>
                  <span className="valor">{formData.bairro}</span>
                </div>
                <div className="dado-item">
                  <span className="label">Cidade:</span>
                  <span className="valor">{formData.cidade}</span>
                </div>
                <div className="dado-item">
                  <span className="label">CEP:</span>
                  <span className="valor">{formData.cep}</span>
                </div>
              </div>

              <div className="dados-plano">
                <h4>Plano Contratado</h4>
                <div className="dado-item">
                  <span className="label">Plano:</span>
                  <span className="valor">{formData.plano}</span>
                </div>
              </div>
            </div>

            <div className="proximos-passos">
              <h3>Próximos Passos</h3>
              <div className="passos-lista">
                <div className="passo">
                  <div className="passo-numero">1</div>
                  <div className="passo-conteudo">
                    <h4>Análise Técnica</h4>
                    <p>Nossa equipe técnica analisará a viabilidade da instalação em seu endereço.</p>
                  </div>
                </div>
                <div className="passo">
                  <div className="passo-numero">2</div>
                  <div className="passo-conteudo">
                    <h4>Contato</h4>
                    <p>Entraremos em contato em até 24 horas para agendar a instalação.</p>
                  </div>
                </div>
                <div className="passo">
                  <div className="passo-numero">3</div>
                  <div className="passo-conteudo">
                    <h4>Instalação</h4>
                    <p>Nossa equipe realizará a instalação no horário agendado.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="sucesso-actions">
              <button onClick={voltarParaHome} className="btn-secundario">
                <i className="fas fa-home"></i>
                Voltar ao Início
              </button>
              <button onClick={irParaCentralAssinante} className="btn-primario">
                <i className="fas fa-user"></i>
                Acessar Central do Assinante
              </button>
            </div>

            <div className="sucesso-info">
              <h3>Precisa de Ajuda?</h3>
              <p>Entre em contato conosco:</p>
                             <div className="contatos-info">
                 <div className="contato-item">
                   <i className="fas fa-phone"></i>
                   <span>(22) 3012-7144 / (22) 99961-1338</span>
                   <a 
                     href="https://wa.me/5522999611338" 
                     target="_blank" 
                     rel="noopener noreferrer"
                     className="btn-whatsapp-contato"
                     title="Enviar mensagem no WhatsApp"
                   >
                     <i className="fab fa-whatsapp"></i>
                   </a>
                 </div>
                 <div className="contato-item">
                   <i className="fas fa-envelope"></i>
                   <span>contato@unetbandalarga.com.br</span>
                 </div>
                 <div className="contato-item">
                   <i className="fas fa-map-marker-alt"></i>
                   <span>Rua Engenheiro Luiz Carlos Gomes Carvalho, 211 - Ururai - Campos dos Goytacazes - RJ</span>
                 </div>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sucesso; 